import angular from 'angular';
import propertyTypeSelection from './propertyTypeSelection';

export default angular
  .module('components.propertyTypeSelection', [])
  .component('propertyTypeSelection', propertyTypeSelection).name;
